// Extracted verbatim from the pre-migration index.html during the TanStack migration.
// Do not edit semantics here — edit the source scripts and keep SSR-execution safety in mind.

export const ORG_JSONLD = String.raw`
{
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Rex & Sons RVs",
      "legalName": "Rex & Sons RVs Inc",
      "url": "https://www.rexandsonsrvs.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.rexandsonsrvs.com/favicon-512.png",
        "width": 512,
        "height": 512
      },
      "sameAs": [
        "https://www.facebook.com/RexAndSonsRV",
        "https://www.instagram.com/rexandsons_rv",
        "https://www.youtube.com/playlist?list=UUOMXdujngOKkWVso3syNywA"
      ]
    }
`;

export const MANIFEST_LOADER_SCRIPT = String.raw`
(function(){
        var fired=false;
        var SB='https://cpkvmigljcrjxctoixoq.supabase.co';
        function applyManifest(d){
          if(d&&d.map){
            window.__IMAGE_MANIFEST__=d.map;
            window.dispatchEvent(new Event('image-manifest-ready'));
            return true;
          }
          return false;
        }
        function loadManifest(){
          if(fired)return;fired=true;
          try{
            // Static manifest only. Missing/corrupt files leave normal per-image
            // CDN/source fallbacks in charge, never a site-wide database scan.
            fetch(SB+'/storage/v1/object/public/splash-assets/manifest/site-manifest.version.txt',{credentials:'omit'})
              .then(function(r){return r.ok?r.text():null;})
              .then(function(v){
                if(!v||!v.trim())return;
                return fetch(SB+'/storage/v1/object/public/splash-assets/manifest/site-manifest.json?v='+encodeURIComponent(v.trim()),{credentials:'omit'})
                  .then(function(r){return r.ok?r.json():null;})
                  .then(applyManifest);
              })
              .catch(function(){});
          }catch(e){}
        }
        var events=['wheel','pointerdown','touchstart','keydown'];
        function onAct(e){
          if(document.hidden||!e.isTrusted)return;
          loadManifest();events.forEach(function(e){window.removeEventListener(e,onAct)});
        }
        events.forEach(function(e){window.addEventListener(e,onAct,{passive:true})});
      })();
`;

export const HERO_PRELOAD_SCRIPT = String.raw`
(function(){
        var p=location.pathname;
        var base='https://cpkvmigljcrjxctoixoq.supabase.co';
        if(p.indexOf('/public-files/')===0){location.replace(base+'/storage/v1/object/public/splash-assets'+p.replace('/public-files',''));return;}
        // Homepage route head exclusively owns layout-matched image preloads.
        // Root scripts run before leaf links are parsed and cannot safely
        // guess Classic sources. Picture discovery is the safe fallback.
        try{
          var path=p||'/';
          if(path.length>1 && path.charAt(path.length-1)==='/'){path=path.slice(0,-1);}
          var canonicalUrl='https://www.rexandsonsrvs.com'+path;
          var canon=document.getElementById('canonical-link');
          if(canon){canon.setAttribute('href',canonicalUrl);}
          var ogu=document.querySelector('meta[property="og:url"]');
          if(ogu){ogu.setAttribute('content',canonicalUrl);}
        }catch(e){}
      })();
`;

// (The legacy font self-heal script was removed: fonts now load once from the
// content-hashed bundled /assets/ URL, so re-fetching with a ?v=3 query only
// created a duplicate font download on unit pages.)

// Direct Google tag waits for hydration and idle (paid clicks bypass idle),
// always after trusted regional permission. The heavier GTM
// container (including its Clarity tags) waits for engagement, then browser idle.
// (mirrors src/lib/googleAdsConversion.ts).
export const GTM_SCRIPT = String.raw`
(function(){
        if(location.pathname==='/kiosk'||location.pathname==='/product/kiosk') return;
        var CONSENT=['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','IS','LI','NO','GB','CH','CA'];
        var fired=false;
        window.dataLayer=window.dataLayer||[];
        function gtag(){dataLayer.push(arguments);}
        window.gtag=window.gtag||gtag;
        function refused(){
          try{return localStorage.getItem('cookie_consent')==='denied'||navigator.globalPrivacyControl===true;}catch(e){return true;}
        }
        var engaged=false,allowed=false,heavyScheduled=false,heavyLoaded=false;
        var engagementEvents=['scroll','wheel','pointerdown','touchstart','keydown'];
        function removeEngagementListeners(){
          engagementEvents.forEach(function(e){window.removeEventListener(e,onEngagement);});
        }
        function loadHeavyTags(){
          if(heavyLoaded||!allowed||refused())return;
          heavyLoaded=true;
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-ND8MF5DV');
        }
        function scheduleHeavyTags(){
          if(!allowed||!engaged||heavyScheduled||refused())return;
          heavyScheduled=true;
          if(typeof window.requestIdleCallback==='function')window.requestIdleCallback(loadHeavyTags);
          else window.setTimeout(loadHeavyTags,0);
        }
        function onEngagement(e){
          if(document.hidden||!e.isTrusted)return;
          engaged=true;
          removeEngagementListeners();
          scheduleHeavyTags();
        }
        engagementEvents.forEach(function(e){window.addEventListener(e,onEngagement,{passive:true});});
        gtag('consent','default',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
        function consentRequired(cb){
          try{
            // Non-rendering regional checks must not compete with CSS or the LCP photo.
            window.__googleAdsRegionLookup=fetch('/cdn-cgi/trace',{signal:AbortSignal.timeout(2000),cache:'no-store',priority:'low'})
              .then(function(r){if(!r.ok)throw new Error('trace unavailable');return r;})
              .catch(function(){return fetch('/api/public/ad-region',{signal:AbortSignal.timeout(2000),cache:'no-store',priority:'low'});});
            window.__googleAdsRegionLookup.then(function(r){
              if(!r.ok)return cb(true);
              return r.text().then(function(t){
                var m=t.match(/^loc=([A-Z0-9]{2})$/m);
                var c=m&&m[1];
                cb(!c||c==='XX'||c==='T1'||CONSENT.indexOf(c)!==-1);
              });
            }).catch(function(){cb(true);});
          }catch(e){cb(true);}
        }
        var paidClick=false;
        try{
          var params=new URLSearchParams(location.search);
          paidClick=['gclid','gbraid','wbraid'].some(function(key){return !!params.get(key);});
        }catch(e){}
        window.__googleAdsReady=new Promise(function(resolve){
          function initialize(){
          if(refused()){removeEngagementListeners();resolve(false);return;}
          consentRequired(function(blocked){
            window.__googleAdsRegionBlocked=blocked;
            if(blocked||refused()){removeEngagementListeners();resolve(false);return;}
            function startDirectTag(){
            if(refused()){removeEngagementListeners();resolve(false);return;}
            if(fired){resolve(true);return;}fired=true;
            allowed=true;
            gtag('consent','update',{ad_storage:'granted',ad_user_data:'denied',ad_personalization:'granted'});
            var gads=document.createElement('script');
            gads.async=true;
            gads.src='https://www.googletagmanager.com/gtag/js?id=G-STTW5DBSPG';
            (document.head||document.getElementsByTagName('head')[0]||{appendChild:function(){}}).appendChild(gads);
            gtag('js',new Date());
            gtag('set','developer_id.dZjgwMW',true);
            gtag('config','G-STTW5DBSPG');
            // Google Ads tag + conversions are skipped entirely in consent regions.
            gtag('config','AW-989017611',{allow_enhanced_conversions:false});
            resolve(true);
            scheduleHeavyTags();
            }
            startDirectTag();
          });
          }
          if(paidClick){initialize();return;}
          function afterHydration(){
            window.removeEventListener('rex-app-hydrated',afterHydration);
            if(typeof window.requestIdleCallback==='function')window.requestIdleCallback(initialize,{timeout:2500});
            else window.setTimeout(initialize,1500);
          }
          if(window.__rexAppHydrated)afterHydration();
          else window.addEventListener('rex-app-hydrated',afterHydration,{once:true});
        });
        window.addEventListener('storage',function(e){
          if(e.key==='cookie_consent'&&refused()){
            gtag('set','user_data',null);
            gtag('consent','update',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
            location.reload();
          }
        });
      })();
`;

export const ADMIN_AUTH_BOOT_GUARD_SCRIPT = String.raw`
(function(){
  var p = location.pathname;
  if (p === '/admin/login' || p.indexOf('/admin/') !== 0) return;
  try {
    var key = 'sb-${import.meta.env["VITE_SUPABASE_PROJECT_ID"]}-auth-token';
    if (!localStorage.getItem(key)) {
      location.replace('/admin/login');
    }
  } catch (e) {}
})();
`;



